import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app.config";
import { AppMain } from "./app/app-main";
bootstrapApplication(AppMain, appConfig).catch((err) => console.error(err));
